// Recovered compiled webpack factory 73360. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      Router: function () {
        return o.default;
      },
      createRouter: function () {
        return _;
      },
      default: function () {
        return p;
      },
      makePublicRouterInstance: function () {
        return m;
      },
      useRouter: function () {
        return h;
      },
      withRouter: function () {
        return l.default;
      },
    }));
  let n = r(28140),
    a = n._(r(12115)),
    o = n._(r(58110)),
    i = r(79862),
    s = n._(r(42444)),
    l = n._(r(15657)),
    u = {
      router: null,
      readyCallbacks: [],
      ready(e) {
        if (this.router) return e();
        this.readyCallbacks.push(e);
      },
    },
    c = [
      "pathname",
      "route",
      "query",
      "asPath",
      "components",
      "isFallback",
      "basePath",
      "locale",
      "locales",
      "defaultLocale",
      "isReady",
      "isPreview",
      "isLocaleDomain",
      "domainLocales",
    ],
    f = ["push", "replace", "reload", "back", "prefetch", "beforePopState"];
  function d() {
    if (!u.router)
      throw Object.defineProperty(
        Error(
          'No router instance found.\nYou should only use "next/router" on the client side of your app.\n',
        ),
        "__NEXT_ERROR_CODE",
        { value: "E394", enumerable: !1, configurable: !0 },
      );
    return u.router;
  }
  (Object.defineProperty(u, "events", { get: () => o.default.events }),
    c.forEach((e) => {
      Object.defineProperty(u, e, { get: () => d()[e] });
    }),
    f.forEach((e) => {
      u[e] = function () {
        for (var t = arguments.length, r = Array(t), n = 0; n < t; n++) r[n] = arguments[n];
        return d()[e](...r);
      };
    }),
    [
      "routeChangeStart",
      "beforeHistoryChange",
      "routeChangeComplete",
      "routeChangeError",
      "hashChangeStart",
      "hashChangeComplete",
    ].forEach((e) => {
      u.ready(() => {
        o.default.events.on(e, function () {
          for (var t = arguments.length, r = Array(t), n = 0; n < t; n++) r[n] = arguments[n];
          let a = "on" + e.charAt(0).toUpperCase() + e.substring(1);
          if (u[a])
            try {
              u[a](...r);
            } catch (e) {
              (console.error("Error when running the Router event: " + a),
                console.error((0, s.default)(e) ? e.message + "\n" + e.stack : e + ""));
            }
        });
      });
    }));
  let p = u;
  function h() {
    let e = a.default.useContext(i.RouterContext);
    if (!e)
      throw Object.defineProperty(
        Error(
          "NextRouter was not mounted. https://nextjs.org/docs/messages/next-router-not-mounted",
        ),
        "__NEXT_ERROR_CODE",
        { value: "E509", enumerable: !1, configurable: !0 },
      );
    return e;
  }
  function _() {
    for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) t[r] = arguments[r];
    return (
      (u.router = new o.default(...t)),
      u.readyCallbacks.forEach((e) => e()),
      (u.readyCallbacks = []),
      u.router
    );
  }
  function m(e) {
    let t = {};
    for (let r of c) {
      if ("object" == typeof e[r]) {
        t[r] = Object.assign(Array.isArray(e[r]) ? [] : {}, e[r]);
        continue;
      }
      t[r] = e[r];
    }
    return (
      (t.events = o.default.events),
      f.forEach((r) => {
        t[r] = function () {
          for (var t = arguments.length, n = Array(t), a = 0; a < t; a++) n[a] = arguments[a];
          return e[r](...n);
        };
      }),
      t
    );
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
